// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"FeedbackFormList_listContainer__1qehG","item":"FeedbackFormList_item__JlBte","title":"FeedbackFormList_title__xG5u6"};